// extracted by mini-css-extract-plugin
module.exports = {"lds-spinner":"Spinner_lds-spinner__JoopQ","small":"Spinner_small___lB9T"};